import React, { useEffect, useState } from "react";
import { css } from "@emotion/core";
// First way to import
import { MoonLoader } from "react-spinners";
import { Observer, GLOBAL_EVENT } from "../../../Observer";
import { css as CSS } from 'glamor';

// Can be a string as well. Need to ensure each key-value pair ends with ;
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

const spinner_styles = CSS({
    position: 'absolute !important',
    width: '100%',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    zIndex: '2',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});

const SpinnerModal = () => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        Observer.on(GLOBAL_EVENT.SPINNER.OPEN, () => {
            setLoading(true);
        });
        Observer.on(GLOBAL_EVENT.SPINNER.CLOSE, () => {
            setLoading(false);
        });
    });
    return (
        <div className={`${spinner_styles} ${!loading && 'd-none' }`}>
            <div className="sweet-loading">
                <MoonLoader
                    css={override}
                    size={60}
                    color={"#EC6139"}
                    loading={loading}
                />
            </div>
        </div>
    );
}

export default SpinnerModal;